<template>
  <div class="multiUploadFile-container">
    <el-upload
      ref="multiUploadFile"
      :action="uploadFile"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :on-success="successMultiFile"
      :on-error="errorMultiFile"
      multiple
      :show-file-list="showList"
      :limit="limit"
      :on-exceed="handleExceed"
      :file-list="fileList">
      <span v-if="!oldSpan" slot="tip" class="el-upload__tip" style="color:#99a9bf;margin-right: 10px;float: left;margin-top: 10px;">最多上传 {{limit}} 个文件，每个文件且不超过 2GB</span>
      <el-button v-if="oldButton" size="small" icon="el-icon-upload2">点击上传</el-button>
      <el-button v-else size="medium" type="primary">点击上传</el-button>
      <span v-if="oldSpan" slot="tip" class="el-upload__tip" style="color:#99a9bf;margin-left: 10px">最多上传 {{limit}} 个文件，每个文件且不超过 2GB</span>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: 'MultiFile',
  props: {
    limit: {
      type: Number,
      default: 9
    },
    old: {
      type: Array
    },
    showList: {
      type: Boolean,
      default: true
    },
    oldButton: {
      type: Boolean,
      default: true
    },
    oldSpan: {
      type: Boolean,
      default: true
    }
  },
  created() {
    if (this.old !== undefined) {
      if (this.old.length > 0) {
        for (let i of this.old) {
          this.fileids.push(i.id)
          this.fileList.push(i)
        }
        this.$emit('input', this.fileids)
        this.$emit('change', this.fileList)
      }
    }
  },
  data() {
    return {
      uploadFile: process.env.VUE_APP_BASE_API + '/fileUpload/uploadFile',
      fileids: [],
      fileList: []
    }
  },
  methods: {
    handleRemove(file, fileList) {
      if (file.response !== undefined && file.response.data !== null ) {
        const i = this.fileids.indexOf(file.response.data.dFileid)
        if (i !== -1) {
          this.fileids.splice(i, 1)
        }
      } else {
        if (file.id !== undefined && file.id !== null ) {
          const i = this.fileids.indexOf(file.id)
          if (i !== -1) {
            this.fileids.splice(i, 1)
          }
        }
      }
      this.$emit('input', this.fileids)
      let newList = []
      for (const item of this.fileList) {
        if (item.id && this.fileids.indexOf(item.id) > -1) {
          newList.push({ ...item });
        }
      }
      this.fileList = newList
      this.$emit('change', newList)
    },
    errorMultiFile() {
      this.$message({
        type: 'error',
        message: '文件上传失败，请稍后重试'
      })
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多上传 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name } ？`)
    },
    successMultiFile(response, file, fileList) {
      if (response.success) {
        this.fileids.push(response.data.dFileid)
        this.$emit('input', this.fileids)
        let newList = [...this.fileList]
        if (fileList && fileList.length > 0) {
          for (const item of fileList) {
            if (item.response && item.response.data) {
              newList.push({
                id: item.response.data.dFileid,
                name: item.response.data.dName + '.' + item.response.data.dType,
                url: item.response.data.file_url
              });
            }
          }
        }
        this.fileList = newList
        this.$emit('change', newList)
      } else {
        this.$message({
          type: 'error',
          message: response.msg
        })
      }
    },
    clearMultiFile() {
      this.fileids = []
      this.fileList = []
      this.$emit('input', this.fileids)
      this.$refs['multiUploadFile'].clearFiles()
    }
  }
}
</script>

<style scoped>

</style>
